import React from 'react'

function Entreprise() {
  return (
    <div>Entreprise</div>
  )
}

export default Entreprise